export default {
  state: {
    globalSuccessAlertText: '',
    globalErrorAlertText: '',
    timeout: 5
  },

  getters: {
    showGlobalSuccessAlert(state) {
      return state.globalSuccessAlertText.length > 0;
    },

    showGlobalErrorAlert(state) {
      return state.globalErrorAlertText.length > 0;
    },

    globalSuccessAlertText(state) {
      return state.globalSuccessAlertText;
    },

    globalErrorAlertText(state) {
      return state.globalErrorAlertText;
    },

    globalAlertTimeout(state) {
      return state.timeout;
    }
  },

  mutations: {
    setGlobalAlert(state, options) {
      state.timeout = options.timeout || 5;
      if (options.error) {
        state.globalErrorAlertText = options.msg;
      } else {
        state.globalSuccessAlertText = options.msg;
      }
    },

    clearGlobalAlerts(state) {
      state.globalErrorAlertText = '';
      state.globalSuccessAlertText = '';
    },

    clearGlobalAlert(state, isError) {
      if (isError) {
        state.globalErrorAlertText = '';
      } else {
        state.globalSuccessAlertText = '';
      }
    }
  }
};
